// Campaign motion (Unit 2): rotating cross-fade + scroll-pan.
// - Rotating: cross-fade [data-campaign-rotate] layers on an interval.
// - Pan: CSS `animation-timeline: view()` is primary (Chromium/FF); this JS is the
//   feature-detected Safari fallback, running the reference ScrollPanImage math 1:1.
// Idempotent + section-lifecycle aware (shopify:section:load / :unload).
(function () {
  function prefersReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  var SUPPORTS_TIMELINE = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  var rotateTimers = new WeakMap();

  function initRotate(root) {
    root.querySelectorAll('[data-campaign-rotate]').forEach(function (el) {
      if (rotateTimers.has(el)) return;
      var layers = el.querySelectorAll('.campaign-rotate-layer');
      if (!layers.length) return;
      for (var i = 0; i < layers.length; i++) layers[i].classList.toggle('is-active', i === 0);
      if (prefersReduced() || layers.length < 2) return;
      var ms = parseInt(el.getAttribute('data-interval'), 10) || 5000;
      var current = 0;
      var id = window.setInterval(function () {
        layers[current].classList.remove('is-active');
        current = (current + 1) % layers.length;
        layers[current].classList.add('is-active');
      }, ms);
      rotateTimers.set(el, id);
    });
  }

  function initPan(root) {
    if (SUPPORTS_TIMELINE || prefersReduced()) return; // CSS handles it, or motion is off
    root.querySelectorAll('[data-campaign-pan]').forEach(function (img) {
      if (img._panBound) return;
      img._panBound = true;
      var rafId = 0;
      var active = false;
      function update() {
        rafId = 0;
        var rect = img.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var raw = (vh - rect.top) / (vh + rect.height);
        raw = raw < 0 ? 0 : raw > 1 ? 1 : raw;
        img.style.setProperty('--pan', (raw * 100) + '%');
      }
      function schedule() { if (!rafId && active) rafId = requestAnimationFrame(update); }
      var io = new IntersectionObserver(function (entries) {
        active = !!(entries[0] && entries[0].isIntersecting);
        if (active) update();
      }, { rootMargin: '200px 0px' });
      io.observe(img);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      img._panCleanup = function () {
        io.disconnect();
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        if (rafId) cancelAnimationFrame(rafId);
      };
      update();
    });
  }

  function init(root) { initRotate(root); initPan(root); }

  function teardown(root) {
    root.querySelectorAll('[data-campaign-rotate]').forEach(function (el) {
      var id = rotateTimers.get(el);
      if (id) { clearInterval(id); rotateTimers.delete(el); }
    });
    root.querySelectorAll('[data-campaign-pan]').forEach(function (img) {
      if (img._panCleanup) img._panCleanup();
      img._panBound = false;
    });
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
})();
